import React from 'react';
import { useSelector } from 'react-redux';
import { GamesList, ProductPage } from '@homeplay/components';
import { selectCrashGames } from '@homeplay/app';
import classes from './CrashGames.module.scss';
import crashGamesLogo from '../../../../shared/assets/images/crash-games-logo.png';

const CrashGames = () => {
  const crashGames = useSelector(selectCrashGames);

  const getGameLink = (loadParams) => {
    if (loadParams.auth_token) {
      // InOut (Chicken Road)
      return `${process.env.REACT_APP_SPRIBE_BASE_URL}/inout/${loadParams.url_slug}/api/modes/game.html?operatorId=ee2013ed-e1f0-4d6e-97d2-f36619e2eb52&lang=en&theme=&gameCustomizationId=&gsServer=${loadParams.game_server}&lobbyUrl=&authToken=${loadParams.auth_token}&gameMode=${loadParams.url_slug}&currency=ZAR`;
    }
    // Spribe (Aviator)
    return `${process.env.REACT_APP_SPRIBE_BASE_URL}/spribe/${loadParams.url_slug}/?currency=ZAR&jurisdiction=CW&lang=EN&token=m&operator=default&extra=${loadParams.game_server}&user=${loadParams.user}`;
  };

  return (
    <ProductPage getGameLink={getGameLink} customClass={classes.CrashGames}>
      <div className="container">
        <img
          className={classes.Logo}
          src={crashGamesLogo}
          alt="Crash Games"
          width="228"
          height="100"
        />
        {crashGames && <GamesList games={crashGames} />}
      </div>
    </ProductPage>
  );
};

export default CrashGames;
